import { extraccionSimple } from './dbhelper';
export const obtenerFronteras = (params) => {
    
    return extraccionSimple("fronteras");
};
